import { DefaultButton } from '@fluentui/react/lib/Button';
import { logUsage } from 'owa-analytics';
import { saveCalendarViewText } from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { lazyShowAddOrEditSaveViewDialog } from 'owa-save-calendar-view-dialog';
import * as React from 'react';
import {
    lazyGetSavedCalendarViewsMap,
    MAX_SAVED_CALENDAR_VIEWS,
} from 'owa-save-calendar-view-data';

const styles = require('../../components/CalendarModuleCommandBar.scss');

export function getSurfaceCreateSaveViewMenuItems(
    isSavedViewSelected: boolean
): FilterableMenuItem[] {
    if (!isFeatureEnabled('cal-saveCalendarView')) {
        return [];
    }

    const getSaveViewButtonDisabled = () => {
        if (isSavedViewSelected) {
            return true;
        }
        const getSavedCalendarViewsMap = lazyGetSavedCalendarViewsMap.tryImportForRender();
        if (getSavedCalendarViewsMap?.().size >= MAX_SAVED_CALENDAR_VIEWS) {
            return true;
        }
        return false;
    };

    const onRender = (item: any): React.ReactNode => {
        const noIcon = {
            iconName: ' ',
            className: styles.viewMenuIcon,
        };
        const onSaveViewClick = () => {
            logUsage('launchSaveViewDialog');
            lazyShowAddOrEditSaveViewDialog.importAndExecute(null);
        };
        return (
            <DefaultButton
                className={styles.viewMenuButton}
                onClick={onSaveViewClick}
                disabled={getSaveViewButtonDisabled()}
                iconProps={noIcon}
                text={loc(saveCalendarViewText)}
                ariaLabel={loc(saveCalendarViewText)}
                styles={{
                    label: styles.viewMenuButtonLabel,
                }}
            />
        );
    };

    return [
        new FilterableMenuItem({
            [FilterableMenuItemArgs.key]: 'CreateSaveViewDivider',
            [FilterableMenuItemArgs.name]: '-',
        }),
        new FilterableMenuItem({
            [FilterableMenuItemArgs.key]: 'CreateSaveView',
            [FilterableMenuItemArgs.onRender]: onRender,
            [FilterableMenuItemArgs.title]: loc(saveCalendarViewText),
        }),
    ];
}
